/**
 * Composition methods for the home view
 * 
 * Author: Andrea López <andrea.lopez@huumun.com>
 */

import { useRouter } from 'vue-router';

export function homeSectionsComposition () {
    const router = useRouter();

	// Function to navigate to gallery
    function navigateToGallery (section: string) {
        router.push(`/covid-hub/gallery/${section}`);
    }

    return { navigateToGallery }
}